<template>
  <div>
    <vue-multi-select
        ref="multiSelect"
        v-model="values"
        :options="options"
        :btnLabel="btnFunction"
        @open="open"
        @close="close"
        :selectOptions="data">
      <template v-slot:data="{data}">
        {{data}}
        <input type="checkbox" :checked="data.selected"/>
        <span>{{data.name}}</span>
      </template>
    </vue-multi-select>

<!--    {{values}}-->


<!--    <button-->
<!--        @click="openManually">-->
<!--      Open manually-->
<!--    </button>-->
  </div>
</template>

<script>
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';

export default {
  props : ['actionCount', 'multiFormIndex'],
  data() {
    return {

      // btnLabel: valueLength => `선택한 데이터: (${valueLength.length})`,
      name: 'first group',
      valueLength: [],
      count : 0,
      values: [],
      data: [{'name' : '폴더', 'list':[{'name': '테스트를 진행해주세요'}]}],


      // filters: [{
      //   nameAll: 'Select all',
      //   nameNotAll: 'Deselect all',
      //   func() {
      //     return true;
      //   },
      // }, {
      //   nameAll: 'select <= 10',
      //   nameNotAll: 'Deselect <= 10',
      //   func(elem) {
      //     return elem.name <= 10;
      //   },
      // }, {
      //   nameAll: 'Select contains 2',
      //   nameNotAll: 'Deselect contains 2',
      //   func(elem) {
      //     return elem.name.indexOf('2') !== -1;
      //   },
      // }],
      options: {
        multi: true,
        groups: true,
      },
      testList : []
    };
  },
  watch : {

  },
  computed : {

  },
  methods: {
    btnFunction(){
      return '트리거 데이터: ' + this.count;
    },
    // openManually() {
    //   this.$refs.multiSelect.openMultiSelect();
    // },
    open() {
      console.log('open');

      this.updateValues();


      if(this.$store.state.userStore.testData != null && this.$store.state.userStore.testData != undefined && this.$store.state.userStore.testData.length > 0){

        var topObj = [];

        console.log(this.$store.state.userStore.testData)
        // var jsonKeys = Object.keys(this.$store.state.userStore.testData);

        for(var k = 0; k < this.$store.state.userStore.testData.length; k++){
          var insideObj = [];
          // var testkey = Object.keys(this.$store.state.userStore.testData[k]);
          // topObj.push(this.$store.state.userStore.testData[k]["key"])
          console.log(this.$store.state.userStore.testData[k]["key"])

          console.log(this.$store.state.userStore.testData[k]["value"])

          if(Object.keys(this.$store.state.userStore.testData[k]["value"]).length > 0){

            var valuejson = this.$store.state.userStore.testData[k]["value"];

            var jsonKeys = Object.getOwnPropertyNames(valuejson);

            for(var name of jsonKeys){
              console.log("name",name)
              console.log(valuejson[name])

              if(valuejson[name] != null && typeof valuejson[name] == "object"){
                console.log(Object.keys(valuejson[name]))

                for(var name2 of Object.keys(valuejson[name])){
                  insideObj.push({'name': name + "." + name2, 'value': this.$store.state.userStore.testData[k]["key"]})

                }

              } else {
                insideObj.push({'name': name, 'value': this.$store.state.userStore.testData[k]["key"]})

              }

              // if(Object.keys(valuejson[name]) > 0){
              //   console.log("array:", name)
              // }

              console.log(insideObj)

            }
          }

          topObj.push({'name' : this.$store.state.userStore.testData[k].key, 'list' : insideObj})

        }


        // for(var i = 0; i < this.$store.state.userStore.testData.length; i++){
        //   var insideObj = [];
        //
        //   var keys = Object.keys(this.$store.state.userStore.testData[i].value)
        //   console.log("keys:", keys)
        //
        //   for(var j = 0; j < keys.length; j++){
        //     insideObj.push({'name': keys[j], 'value': this.$store.state.userStore.testData[i].key})
        //     console.log("insideObj:", insideObj)
        //
        //     // var key = this.$store.state.userStore.testData[i].key + "::" + keys[j]
        //     //
        //     // var obj = {id : key, title : key}
        //     // this.testList.push(obj)
        //
        //   }
        //
        //   topObj.push({'name' : this.$store.state.userStore.testData[i].key, 'list' : insideObj})
        //
          console.log("top obj:", topObj)
        //
        // }

        this.data = topObj


      } else {
        topObj = [];
        var testObj = [];
        testObj.push({'name': '테스트를 진행해주세요', disabled:true})

        topObj.push({'name' : '폴더', 'list':testObj})
        this.data = topObj
      }




    },
    setThisData(){

    },
    close() {


      this.count = this.values.length
      console.log(this.values)
      console.log('close');

      var topObj = [];
      var testObj = [];
      testObj.push({'name': '테스트를 진행해주세요', disabled:true})

      topObj.push({'name' : '폴더', 'list':testObj})
      this.data = topObj

      console.log(this.data)

      console.log(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value)

      // values

      this.$parent.addWorkflowValue(this.values, this.actionCount, this.multiFormIndex)

      // this.$emit("saveSelectedData", this.values)



    },

    updateValues(){

      if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value == undefined){
        console.log("이게 효과 있으려나 ")
        this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value = "";
      } else {

        if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value.indexOf("[{") > -1){

          console.log(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value.indexOf("[{"))


          var val = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value
          // if(val.indexOf("[{") > -1){
          var start = val.indexOf("[{");
          var end = val.indexOf("}]");

          console.log(val.substr(start, end+2))

          var vvval = JSON.parse(val.substr(start, end+2))

          var testlist = []

          var key = "";
          for(var i = 0; i < vvval.length; i++){
            key = vvval[i].value;

            var oobbjj = {name :  vvval[i].name, value :  vvval[i].value}

            testlist.push(oobbjj)

          }




          var oobjData = {'name' : key, 'list' : testlist}
          this.data.push(oobjData)

          this.values = JSON.parse(val.substr(start, end+2))
          // this.data = JSON.parse(val.substr(start, end+2))
          this.count = vvval.length
          // this.valueLength = vvval
          // this.valueLength = vvval.length


          console.log("ㅍ미ㅕㄷㄴ :" , vvval.length)


          console.log("-------------------------------------------------------------------")

        }
      }



    }

  },
  components: {
    vueMultiSelect,
  },
  mounted() {
    //https://vue-multi-select.tuturu.io/#a_simple_multiselect 참고
    console.log("userEditorTestBox.mounted")
    // console.log(this.$store.state.userStore.testData)
    // console.log(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value)

    if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value == undefined){
      console.log("이게 효과 있으려나 ")
      this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value = "";
    } else {

      if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value.indexOf("[{") > -1){

        console.log(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value.indexOf("[{"))


        var val = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value
        // if(val.indexOf("[{") > -1){
          var start = val.indexOf("[{");
          var end = val.indexOf("}]");

          console.log(val.substr(start, end+2))

        var vvval = JSON.parse(val.substr(start, end+2))

        var testlist = []

         var key = "";
        for(var i = 0; i < vvval.length; i++){
          key = vvval[i].value;

           var oobbjj = {name :  vvval[i].name, value :  vvval[i].value}

          testlist.push(oobbjj)

        }




         var oobjData = {'name' : key, 'list' : testlist}
        this.data.push(oobjData)

        this.values = JSON.parse(val.substr(start, end+2))
        // this.data = JSON.parse(val.substr(start, end+2))
        this.count = vvval.length
        // this.valueLength = vvval
  // this.valueLength = vvval.length




              // '[{"name":"name","value":"리스트에 리드(trig_", "selected":"true"}]'

          // this.values = JSON.parse(val.substr(start, end + 2))
          // this.data = JSON.parse(val.substr(start, end + 2))



          // this.values = [{name:"name",value:"리스트에 리드(trig_"}]


        console.log("ㅍ미ㅕㄷㄴ :" , vvval.length)


        // }


      console.log("-------------------------------------------------------------------")






      }
    }


    //



    // this.data = [{name:'1번' , list : [{value: 1, name: 'Item 1'}]}, {name:'1번' , list : [{value: 1, name: 'Item 1'}]}]

    // if(this.$store.state.userStore.testData != null){
    //   var topObj = [];
    //   for(var i = 0; i < this.$store.state.userStore.testData.length; i++){
    //     var insideObj = [];
    //
    //     var keys = Object.keys(this.$store.state.userStore.testData[i].value)
    //     console.log("keys:", keys)
    //
    //     for(var j = 0; j < keys.length; j++){
    //       insideObj.push({'name': keys[j], 'value': this.$store.state.userStore.testData[i].key})
    //       console.log("insideObj:", insideObj)
    //
    //       // var key = this.$store.state.userStore.testData[i].key + "::" + keys[j]
    //       //
    //       // var obj = {id : key, title : key}
    //       // this.testList.push(obj)
    //
    //     }
    //
    //     topObj.push({'name' : this.$store.state.userStore.testData[i].key, 'list' : insideObj})
    //
    //     console.log("top obj:", topObj)
    //
    //   }
    //
    //   this.data = topObj
    // }

    // console.log(this.testList)
  },
  created(){
    console.log("userEditorTestBox.created")

    // console.log(this.$store.state.userStore.testData)

  }
};
</script>